import { GlobalConstants } from './../lib/global-constants';
import { Constants } from './../lib/constants';
import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, ViewContainerRef, AfterViewChecked, TemplateRef } from '@angular/core';
import { DatePickerRange, IAutocompleteComponent, IColumnConfiguration, IDatePickerRange, IPaginatorChangeEventData, IPaginatorComponent, ITableComponent } from '@tylertech/forge';
import { DialogService } from '@tylertech/forge-angular';
import { DatePipe } from '@angular/common';
import { ViewMeetingComponent } from '../lib/popup/view-meeting/view-meeting.component';
import { ViewMeetingsDetail } from '../lib/models/view-meeting.model';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SearchDataModel, SearchResultReponseModel, SearchResultRequestModel } from '../lib/models/meeting-manager.model';
import { SnackbarService } from '../lib/services/snackbar.service';
import { DataService } from 'app/core/services/data.service';
import { Subscription } from 'rxjs';
import { MeetingTypeList } from '../lib/models/meeting-type-model.model';
import { MeetingMapping } from '../lib/mapping/meeting-mapping';
import { MeetingManagerService } from '../lib/services/meeting-manager.service';
import * as _ from 'lodash';
import moment from 'moment';
import { SharedCommonService } from 'app/shared/services/shared-common.service';
import { options } from '@fullcalendar/core/preact';

@Component({
  selector: 'appc-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  standalone: false,
})
export class SearchResultComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  filterPanel = true;
  appliedKeyword = '';
  public searchDataSource: SearchDataModel = new SearchDataModel();
  private subscriptions: Subscription = new Subscription();
  allMeetingTypes: Array<MeetingTypeList> = [];
  selectedMeetingTypes: number[] = [];
  searchResultsDataSource: Array<ViewMeetingsDetail> = [];
  currentStartRecordIndex = 0;
  pageSize = 0;
  pageNo = 1;
  loadedRecordLength = 0;
  columnConfigurations: IColumnConfiguration[] = [
    {
      header: this.constants.searchResultFields.meetingName.label,
      property: this.constants.searchResultFields.meetingName.property,
      template: (index: number, div: HTMLElement, rowData: any) =>
        this.handleLongNameStyling(rowData, this.constants.searchResultFields.meetingName.property, index),
      cellStyle: { cursor: 'pointer'},
      stopCellTemplateClickPropagation: true
    },
    {
      header: this.constants.searchResultFields.meetingDate.label,
      property: this.constants.searchResultFields.meetingDate.property,
      template: (index: number, div: HTMLElement, rowData: any) =>
        this.setMeetingDate(index, div, rowData),
      cellStyle: { cursor: 'pointer'},
      stopCellTemplateClickPropagation: true
    },
    {
      header: this.constants.searchResultFields.meetingType.label,
      property: this.constants.searchResultFields.meetingType.property,
      template: (index: number, div: HTMLElement, rowData: any) =>
        this.handleLongNameStyling(rowData, this.constants.searchResultFields.meetingType.property, index),
      cellStyle: { cursor: 'pointer' },
      stopCellTemplateClickPropagation: true
    }, 
    {
      header: this.constants.searchResultFields.description.label,
      property: this.constants.searchResultFields.description.property,
      template: (index: number, div: HTMLElement, rowData: any) =>
        this.handleLongNameStyling(rowData, this.constants.searchResultFields.description.property, index),
      cellStyle: { cursor: 'pointer'},
      stopCellTemplateClickPropagation: true
    },
    {
      header: this.constants.searchResultFields.documentStatus.label,
      property: this.constants.searchResultFields.documentStatus.property,
      template: (index: number, div: HTMLElement, rowData: any) =>
        this.setDocumentStatus(index, div, rowData),
      cellStyle: { cursor: 'pointer'},
      stopCellTemplateClickPropagation: true
    }

  ];
  dateRangeValue: IDatePickerRange;
  invalidDateRange = false;
  @ViewChild('startDate') startDateElement: ElementRef;
  @ViewChild('endDate') endDateElement: ElementRef;
  isOcrContentLoaded = false;
  private expandedOcrRowIndices = new Set<number>();
  @ViewChild('ocrContent', { static: true }) ocrContent: TemplateRef<any>;
  meetingTypeAutocomplete: IAutocompleteComponent;
  constructor(
    public constants: Constants,
    private datePipe: DatePipe,
    public globalConstants: GlobalConstants,
    private dialogService: DialogService,
    private router: Router,
    private route: ActivatedRoute,
    public snackbarService: SnackbarService,
    public dataService: DataService,
    public meetingManagerService: MeetingManagerService,
    private meetingMapping: MeetingMapping,
    public sharedCommonService: SharedCommonService,
    public viewContainerRef: ViewContainerRef
  ) {
    this.pageSize = constants.pageSizeOptions[0];
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      this.searchDataSource.searchKeyword = params.search.trim();
      const meetingConstant = this.constants.meetingConfig;
      this.searchDataSource.filters.startDate = this.datePipe.transform(new Date(meetingConstant.previousMonth), this.globalConstants.format.datePipe);
      this.searchDataSource.filters.endDate = this.datePipe.transform(new Date(meetingConstant.nextMonth), this.globalConstants.format.datePipe);
      this.dateRangeValue = {
        from: this.searchDataSource.filters.startDate,
        to: this.searchDataSource.filters.endDate
      };
      this.getMeetingTypeList();
      this.getSearchResults();
    });
    this.filterPanel = !this.sharedCommonService.isMobileResolution;
  }
  ngAfterViewInit():void{
    this.enhanceIconAccessibility();
  }
  
  enhanceIconAccessibility() {
    const iconElements = document.querySelectorAll('forge-icon');
    if(iconElements?.length){
      iconElements.forEach((icon)=> icon.setAttribute('aria-hidden', 'false'));
    }
  }
  getMeetingTypeList() {
    this.allMeetingTypes = [];
    this.subscriptions.add(this.meetingManagerService.getMeetingTypeList().subscribe((res) => {
      this.allMeetingTypes = _.orderBy(this.meetingMapping.getMeetingTypeList(res), [user => user.title.toLowerCase()], ['asc']);
      if (this.globalConstants.getSessionStorage('searchResultsMeetingTypes')) {
        this.selectedMeetingTypes = this.globalConstants.getSessionStorage('searchResultsMeetingTypes');
      } else {
        this.selectedMeetingTypes = this.allMeetingTypes.map(o => o.id);
      }
    }, (errorObj) => {
      this.snackbarService.showMessage(errorObj.error ? errorObj.error : this.constants.messages.error.internalServerError);
    }));
  }

  redirectToSearch() {
    this.route.queryParams.subscribe(params => {
      if (params.search === this.searchDataSource.searchKeyword) {
        this.getSearchResults();
      } else {
        this.router.navigate(['search-result'], { queryParams: { search: this.searchDataSource.searchKeyword }});
      }
    });
  }

  getSearchResults(isLazyLoading = false, isLastPage = false) {
    this.pageNo = isLazyLoading ? this.pageNo : 1;
    this.searchDataSource.searchKeyword = this.searchDataSource.searchKeyword.trim();
    const url = this.globalConstants.baseUrl + this.constants.serviceUrl.searchResult.search;
    this.subscriptions.add(this.dataService.post(url, this.setSearchRequest()).subscribe(
      (response: SearchResultReponseModel) => {
        if (
          this.searchDataSource.searchResults &&
          isLazyLoading &&
          !isLastPage
        ) {
          this.searchDataSource.searchResults = _.concat(
            this.searchDataSource.searchResults,
            response.searchResults
          );
          this.setDataSource(
            this.currentStartRecordIndex,
            this.currentStartRecordIndex + this.pageSize
          );
        } else {
          this.searchDataSource.searchResults = response.searchResults;
          this.currentStartRecordIndex = isLastPage
            ? this.currentStartRecordIndex
            : 0;
          this.setDataSource(
            this.currentStartRecordIndex,
            this.searchDataSource.searchResults.length > this.pageSize
              ? this.currentStartRecordIndex + this.pageSize
              : this.searchDataSource.searchResults.length
          );
        }
        this.appliedKeyword = this.searchDataSource.searchKeyword;
        this.loadedRecordLength = this.searchDataSource.searchResults.length;
        this.searchDataSource.totalResults = response.totalElements || 0;
        const paginator: IPaginatorComponent | null = document.querySelector(`[id^=search-page-paginator]`);
        if (paginator) {
          paginator.pageIndex = this.pageNo - 1;
        }
      }, (errorObj) => {
        this.snackbarService.showMessage(errorObj.error ? errorObj.error : this.constants.messages.error.internalServerError);
      }));
  }

  setSearchRequest(): SearchResultRequestModel {
    return {
      lastPage: false,
      searchKeyword: this.searchDataSource.searchKeyword,
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      filter: this.searchDataSource.filters
    }
  }

  handleLongNameStyling(rowData: ViewMeetingsDetail, property: string, rowIndex: number) {
    const containerDiv = document.createElement('div');
    const dataDiv = document.createElement('div');
    containerDiv.classList.add('full-column-width');
    dataDiv.classList.add('long-data-styling', 'cell-clamp');
    const tooltip = document.createElement('forge-tooltip');
    const tooltipSpan = document.createElement('span');
    dataDiv.id = `${property}-${rowData.meetingId}-${rowData.recurringId}-${rowIndex}`;
    const isDescription = property === this.constants.searchResultFields.description.property;
    if (isDescription) {
      dataDiv.innerHTML = this.highlightDescription(rowData.description);
      tooltipSpan.innerHTML = this.highlightDescription(rowData.description);
      dataDiv.classList.add('rich-preview');
    } else {
      let value = '';
      if (property === this.constants.searchResultFields.meetingType.property) {
        value = rowData.meetingTypeName || '';
      } else if (property === this.constants.searchResultFields.meetingName.property) {
        value = rowData.meetingTitle;
      }
      dataDiv.innerHTML = tooltipSpan.innerHTML = this.highlightKeywords(value);
    }
    tooltipSpan.classList.add('tooltip-clamp');
    tooltip.setAttribute('placement', 'bottom');
    tooltip.setAttribute('trigger-type', 'hover,longpress,focus');
    tooltip.appendChild(tooltipSpan);
    containerDiv.appendChild(dataDiv);
    containerDiv.appendChild(tooltip);
    containerDiv.addEventListener('click', () => {
      this.openDialog(new CustomEvent('', {detail: {data: rowData}}));
    });
    return containerDiv;
  }
  setMeetingDate(index: number, div: HTMLElement, rowData: ViewMeetingsDetail) {
    div.id = `createdDate-${index}`;
    const createdDateDiv = document.createElement('div');
    createdDateDiv.classList.add('full-column-width');
    createdDateDiv.innerHTML = moment.parseZone(rowData.startDateTime).format(this.globalConstants.format.date) || '';
    createdDateDiv.addEventListener('click', () => {
      this.openDialog(new CustomEvent('', {detail: {data: rowData}}));
    });
    return createdDateDiv;
  }
  openDialog(event: CustomEvent) {
    if (event?.detail?.data?.meetingId) {
      this.dialogService.open(
        ViewMeetingComponent,
        {
          data: {
            meetingId: event.detail.data.id,
            recurringId: event.detail.data.recurringId,
            backgroundColor: event.detail.data.uri
              ? event.detail.data.ui.borderColor
              : "",
            isDirect: event.detail.data.isDirect,
          },
          options: this.constants.setDialogOptions(
            false,
            this.constants.forgeDialog.dialogClass
          )
        }
      );
    }
  }

  setDocumentStatus(index: number, div: HTMLElement, rowData: ViewMeetingsDetail) {
    div.id = `documentStatus-${index}`;
    const documentStatusContainer = document.createElement('div');
    documentStatusContainer.classList.add('full-column-width');
    documentStatusContainer.style.display = "flex";
    documentStatusContainer.style.flexDirection = "column";
    documentStatusContainer.style.rowGap = "1rem";
    if (rowData.agendaStatus === this.constants.agendaItemStatus.posted) {
      documentStatusContainer.append(this.createBadge(this.constants.documentStatusDisplayName.agenda, 'success'));
    }
    if (rowData.minutesStatus === this.constants.minutesStatus.posted) {
      documentStatusContainer.append(this.createBadge(this.constants.documentStatusDisplayName.minutes, 'info'));
    }
    if (rowData.videoStatus === this.constants.youtubeStatus.public) {
      documentStatusContainer.append(this.createBadge(this.constants.documentStatusDisplayName.video, 'warning'));
    }
    documentStatusContainer.addEventListener('click', () => {
      this.openDialog(new CustomEvent('', {detail: {data: rowData}}));
    });
    return documentStatusContainer;
  }
  createBadge(innerHTML: string, theme = 'warning') {
    const badge = document.createElement('forge-badge');
    badge.setAttribute('theme', theme);
    badge.innerHTML = innerHTML;
    return badge;
  }
  navigateToHome() {
    this.router.navigate(['/']);
  }
  
  navigateToKeyword(_selectedKeyword?: string) {
    // Selecting a chip should keep the full list of keywords intact rather than
    // narrowing the search down to the single selected keyword.
    this.redirectToSearch();
  }

  clearSearch(removedKeyword: string) {
    const searchKeywords = this.searchKeywords;
    let searchQuery = "";
    for (const keyword of searchKeywords) {
      if (keyword !== removedKeyword) {
        searchQuery += keyword + " ";
      }
    }

    this.searchDataSource.searchKeyword = searchQuery;
    this.redirectToSearch();
  }

  setTableDetails(event: CustomEvent<IPaginatorChangeEventData>) {
    if (event) {
      this.currentStartRecordIndex =
        event.detail.pageSize * event.detail.pageIndex;
      if (
        this.pageSize === event.detail.pageSize &&
        this.currentStartRecordIndex >= 0
      ) {
        this.performPaginatorAction(event);
      } else {
        this.pageSize = event.detail.pageSize;
        this.pageNo = 1;
        this.getSearchResults(false);
      }
    }
  }

  performPaginatorAction(event: CustomEvent<IPaginatorChangeEventData>) {
    if (
      (this.currentStartRecordIndex + this.pageSize > this.loadedRecordLength ||
        this.currentStartRecordIndex < 0) &&
      this.loadedRecordLength !== this.searchDataSource.totalResults
    ) {
      this.pageNo =
        event.detail.type === this.constants.paginatorTypes.nextPage
          ? this.pageNo + 1
          : this.pageNo === 1
            ? this.pageNo
            : this.pageNo - 1;
      this.getSearchResults(true, event.detail.type === this.constants.paginatorTypes.lastPage);
    } else {
      this.setDataSource(
        this.currentStartRecordIndex,
        this.currentStartRecordIndex + this.pageSize
      );
    }
  }

  setDataSource(startIndex: number, endIndex: number) {
    this.searchResultsDataSource = this.searchDataSource.searchResults.slice(startIndex, endIndex );
    this.isOcrContentLoaded = false;
    this.expandedOcrRowIndices.clear();
  }
  dateRangeChange(event: CustomEvent<DatePickerRange>) {
    if(event.detail.from && event.detail.to && event.detail.from <= event.detail.to) {
      this.dateRangeValue = {
        from: this.setDateFormat(event.detail.from || ''),
        to: this.setDateFormat(event.detail.to || '')
      };
      this.searchDataSource.filters.startDate = this.setDateFormat(event.detail.from);
      this.searchDataSource.filters.endDate = this.setDateFormat(event.detail.to);
      this.invalidDateRange = false;
      // blur date range selection inputs after user selection
      this.startDateElement.nativeElement.blur();
      this.endDateElement.nativeElement.blur();
      this.getSearchResults();
    } else {
      this.invalidDateRange = true;
    }
  }
  setDateFormat(selectedDate: string | Date) {
    return selectedDate ? this.datePipe.transform(selectedDate, this.globalConstants.format.datePipe) : null;
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  openMeetingDialog(meeting: ViewMeetingsDetail) {
    this.openDialog(
      new CustomEvent("", { detail: { data: meeting } })
    );
  }
  returnDateValue(startDateTime: string) {
    return moment.parseZone(startDateTime).format(this.globalConstants.format.date) || '';
  }
  
  ngAfterViewChecked() {
    // call displayOcrSearchedData method only once after change in table data
    if (!this.isOcrContentLoaded) {
      this.displayOcrSearchedData();
    }
  }

  displayOcrSearchedData() {
    const searchTable: ITableComponent | null = document.querySelector(
      `[id^=search-page-items]`
    );
    if (!searchTable) {
      return;
    }
    let allRowsProcessed = true;
    this.searchResultsDataSource.forEach((data, index) => {
      if (!(data.agendaSnippet || data.minutesSnippet)) {
        return;
      }
      if (this.expandedOcrRowIndices.has(index)) {
        return;
      }
      allRowsProcessed = false;
      try {
        if (searchTable.isRowExpanded(index)) {
          this.expandedOcrRowIndices.add(index);
          return;
        }
        searchTable.expandRow(
          index,
          this.setOcrContentContainer(data, index)
        );
        this.expandedOcrRowIndices.add(index);
      } catch {
        // Forge's table may not have finished rendering this row yet; leave it
        // unmarked so the next change-detection pass retries instead of
        // aborting the whole batch and re-inserting duplicate content later.
      }
    });
    if (allRowsProcessed) {
      this.isOcrContentLoaded = true;
    }
  }

  setOcrContentContainer(item: ViewMeetingsDetail, index: number) {
    const embeddedViewRef = this.viewContainerRef.createEmbeddedView(
      this.ocrContent,
      { item, index }
    );
    return embeddedViewRef?.rootNodes[0];
  }

   splitKeyword (keyword: string) {
    const pattern = new RegExp(/"([^"]*)"|(\S+)/gm);
    const tokens = []

    const matches = keyword.match(pattern);
    if (!matches) {
      return keyword;
    }

    for (const match of matches) {
      tokens.push(match);
    }

    return tokens.filter(token => token && token !== '');
  }

  private matchKeywords(): string[] {
    const raw = this.searchKeywords;
    return (Array.isArray(raw) ? raw : [raw])
      .map((token) => token.replaceAll(/"/g, '').trim())
      .filter((token) => token.length);
  }

  private keywordRegex(): RegExp | null {
    const keywords = this.matchKeywords();
    if (!keywords.length) {
      return null;
    }
    const escaped = keywords.map((token) =>
      token.replace(this.constants.findSearchedWordRegex, this.constants.replaceSearchedWordRegex)
    );
    return new RegExp(`(${escaped.join('|')})`, this.constants.regexFlag);
  }

  highlightKeywords(text: string): string {
    if (!text) {
      return text || '';
    }
    const reg = this.keywordRegex();
    return reg ? text.replace(reg, '<mark class="search-highlight">$1</mark>') : text;
  }

  stripHtml(value: string): string {
    if (!value) {
      return '';
    }
    const el = document.createElement('div');
    el.innerHTML = value;
    this.insertBlockSeparators(el);
    return (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim();
  }

  highlightDescription(value: string): string {
    if (!value) {
      return '';
    }
    const container = document.createElement('div');
    container.innerHTML = value;
    this.insertBlockSeparators(container);
    const reg = this.keywordRegex();
    if (reg) {
      this.highlightTextNodes(container, reg);
    }
    return container.innerHTML;
  }

  snippetPreview(value: string): string {
    const text = this.stripHtml(value);
    if (!text) {
      return '';
    }
    let start = -1;
    for (const keyword of this.matchKeywords()) {
      const index = text.toLowerCase().indexOf(keyword.toLowerCase());
      if (index > -1 && (start === -1 || index < start)) {
        start = index;
      }
    }
    const lead = 15;
    if (start > lead) {
      return '… ' + this.highlightKeywords(text.slice(start - lead));
    }
    return this.highlightKeywords(text);
  }

  private insertBlockSeparators(root: HTMLElement): void {
    root.querySelectorAll('br').forEach((br) => br.replaceWith(document.createTextNode(' ')));
    root.querySelectorAll('div, p, li, tr, h1, h2, h3, h4, h5, h6, blockquote, pre').forEach((el) => {
      el.appendChild(document.createTextNode(' '));
    });
  }

  private highlightTextNodes(root: Node, reg: RegExp): void {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes: Text[] = [];
    let current: Node | null = walker.nextNode();
    while (current) {
      textNodes.push(current as Text);
      current = walker.nextNode();
    }
    for (const node of textNodes) {
      const escapedText = this.escapeHtml(node.nodeValue || '');
      const replaced = escapedText.replace(reg, '<mark class="search-highlight">$1</mark>');
      if (replaced !== escapedText) {
        const host = document.createElement('span');
        host.innerHTML = replaced;
        node.replaceWith(...Array.from(host.childNodes));
      }
    }
  }

  private escapeHtml(text: string): string {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  onMeetingTypeChange(selectedMeetingTypes: number[]) {
    this.selectedMeetingTypes = selectedMeetingTypes;
    this.searchDataSource.filters.meetingTypeIds = selectedMeetingTypes?.length == 0 ? [-1] : selectedMeetingTypes;
    this.globalConstants.setSessionStorage("searchResultsMeetingTypes", selectedMeetingTypes);
    this.getSearchResults();
  }

  get shouldDisplaySearchSummary(): boolean {
    if (!this.sharedCommonService.isMobileResolution) {
      return true;
    }
    return !this.filterPanel;
  }

  get searchKeywords () {
    return this.splitKeyword(this.appliedKeyword);
  }
}
